"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ListStoreItemMappingDto = void 0;
const tslib_1 = require("tslib");
const swagger_v4_1 = require("@nestjs/swagger-v4");
const class_transformer_1 = require("class-transformer");
const generated_dto_1 = require("../generated-dto");
class ListStoreItemMappingDto {
    constructor() {
        this.rows = [];
    }
}
tslib_1.__decorate([
    (0, swagger_v4_1.ApiProperty)({ type: () => Object, description: 'Pagination details' }),
    tslib_1.__metadata("design:type", Object)
], ListStoreItemMappingDto.prototype, "pagination", void 0);
tslib_1.__decorate([
    (0, class_transformer_1.Type)(() => generated_dto_1.ReadStoreItemMappingDto),
    (0, swagger_v4_1.ApiProperty)({ type: () => Object, isArray: true, description: 'Rows matched' }),
    tslib_1.__metadata("design:type", Array)
], ListStoreItemMappingDto.prototype, "rows", void 0);
exports.ListStoreItemMappingDto = ListStoreItemMappingDto;
//# sourceMappingURL=ListStoreItemMappingDto.js.map